import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.Delete.IRequest;
type Response = Api.Finance.AccountReceivable.Delete.IResponse;
type Headers = Api.Finance.AccountReceivable.Delete.IHeaders;
const url = '/api/Finance/AccountReceivable/:id';
export default async function accountReceivableDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
